import { DEFAULT_FORM_NAME } from "./determineFormName";

type FormConfig = {
  signupPath: string;
  canResume?: boolean;
};

const FORM_CONFIGS: Record<string, FormConfig> = {
  [DEFAULT_FORM_NAME]: {
    signupPath: "/sign-up/fresh",
    canResume: true,
  },
  "fresh-new-user": {
    signupPath: "/sign-up/fresh",
  },

};

/**
 * Gets the signup page path for a form name (start of flow).
 * @param formName - The form name
 * @returns The signup page path, or default signup path if not found
 */
export function getSignupPathForFormName(formName: string): string {
  return FORM_CONFIGS[formName]?.signupPath
    ?? FORM_CONFIGS[DEFAULT_FORM_NAME].signupPath;
}

/**
 * Whether a restored cart for this form can resume past the start of the flow
 * (e.g. at recipes or checkout). Forms without it restart at page 1.
 * @param formName - The form name
 */
export function canResumeForFormName(formName: string): boolean {
  return Boolean(FORM_CONFIGS[formName]?.canResume);
}

/** Guesses the current form name based on the current URL's path */
export function getFormNameFromPath(pathname: string): string | null {
  for (const [ formName, config ] of Object.entries(FORM_CONFIGS)) {
    if (pathname.startsWith(config.signupPath)) {
      return formName;
    }
  }
  const fallback = pathname.match(/^\/forms\/([^/]+)(\/.*)?$/)?.[1];
  return fallback ?? null;
}
